import Record from './Record';

const Target = Record({
  path: '',
  label: null,
});

export default Target;
